import { render } from "./Notice.vue?vue&type=template&id=1080a9c5&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=1080a9c5&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1080a9c5"]])

export default __exports__